import { motion } from "framer-motion";
import { useEffect, useRef } from "react";
import Button from "../../../components/common/Button";
import SwitchToggle from "../../../components/common/SwitchToggle";
import TimeInputWrapper from "../../../components/TimeWheelPicker/TimeInputWrapper";
import ZodiacTimeWheel from "../../../components/ZodiacTimeWheel";
import { useFormDataStore } from "../../../store/formDataStore";
import { StepProps } from "../../../types/onboarding";
import styles from "../OnboardingPage.module.css";

const StepBirthTime: React.FC<StepProps> = ({ onNext, onBack }) => {
  const { formData, setFormData } = useFormDataStore();
  const buttonRef = useRef<HTMLButtonElement>(null);

  const handleTimeChange = (time: string) => {
    const isValid = /^\d{2}:\d{2}$/.test(time);
    if (!isValid) {
      console.warn("⛔️ Неверный формат времени:", time);
      return;
    }

    setFormData({ birthTime: time });
  };

  const handleToggleChange = (checked: boolean) => {
    setFormData({
      birthTimeUnknown: checked,
      birthTime: checked ? "00:00" : formData.birthTime,
    });
  };

  useEffect(() => {
    if (formData.birthTime || formData.birthTimeUnknown) {
      buttonRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [formData.birthTime, formData.birthTimeUnknown]);

  return (
    <motion.div
      key="step-birth-time"
      initial={{ opacity: 0, x: 100 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -100 }}
    >
      <h2>Время рождения</h2>
      <p>Это важно для расчёта асцендента и домов.</p>

      <ZodiacTimeWheel activeHour={parseInt(formData.birthTime.split(":")[0])} />

      <div className={styles.timeField}>
        <TimeInputWrapper
          value={formData.birthTime}
          onChange={handleTimeChange}
          disabled={formData.birthTimeUnknown}
        />

        <SwitchToggle
          label="Я не знаю время рождения"
          checked={formData.birthTimeUnknown}
          onCheckedChange={handleToggleChange}
        />
      </div>

      <div className={`${styles["button-row"]} ${styles["two-buttons"]}`}>
        <Button onClick={onBack}>Назад</Button>
        <Button
          ref={buttonRef}
          onClick={onNext}
          disabled={
            !formData.birthTimeUnknown && (!formData.birthTime || formData.birthTime === "00:00")
          }
        >
          Далее
        </Button>
      </div>
    </motion.div>
  );
};

export default StepBirthTime;
